import React, { useState } from 'react';
import { isNumber, isAlphabet } from '../../regexFuncs';
import Popover from '@material-ui/core/Popover';
import Services from './../../services/services';
import donateStyles from './../../styles/donateStyles';
import TextFieldComp from './../TextFieldComp';
import CustomButton from '../viewEventUi/CustomButton';
import { useSelector } from 'react-redux';
import toast from 'react-hot-toast';

import InputAdornment from '@material-ui/core/InputAdornment';
import ArrowRightAltSharpIcon from '@material-ui/icons/ArrowRightAltSharp';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import { getUserBrowserStorage } from '../../constants';

const useStyles = makeStyles((theme) => donateStyles(theme));

const Donate = (props) => {
  const classes = useStyles();
  const popoverZIndex = 1301;
  const userDetails = JSON.parse(getUserBrowserStorage('userDetails'));
  const streamInfo = useSelector((state) => state.streamInfo);

  const [donationAmount, setDonationAmount] = useState('');
  const [designation, setDesignation] = useState('');
  const [errors, setErrors] = useState({});

  const checkCharLimit = (value) => {
    const res = value.length <= 150 && isAlphabet(value);
    return res;
  };

  const handleTextChange = (e) => {
    setErrors({});
    const value = e.target.value;
    const x = value === '' ? true : isNumber(value);
    x && setDonationAmount(value);
  };

  const handleDesignationChange = (e) => {
    const value = e.target.value;
    const x = value === '' ? true : checkCharLimit(value);
    x && setDesignation(value);
  };

  const validationFunc = () => {
    let errors = {};
    if (!Number(donationAmount)) {
      errors.donationAmount = 'Enter a value';
    }

    setErrors(errors);
    const errorStatus = Object.keys(errors).length === 0;
    return errorStatus;
  };

  const donateFunc = async () => {
    const formValid = validationFunc();

    if (formValid) {
      const strWindowFeatures =
        'location=yes,height=570,width=520,scrollbars=yes,status=yes';
      const reqObj = {
        userId: userDetails?.userId || 0,
        email: userDetails?.email || '',
        eventId: streamInfo.eventID,
        donationAmount: donationAmount,
        designation: designation || 'No message',
      };

      try {
        const res = await Services.create_transaction(reqObj);
        if (res.data.responseCode === 200) {
          toast.success(res.data.details);
          window.open(res.data.paymentUrl, '_blank', strWindowFeatures);
          setDonationAmount('');
          setDesignation('');
          props.handleClose();
        } else {
          toast.error(res.data.details);
        }
      } catch (error) {
        toast.error('Unknown error');
      }
    }
  };

  const handleEnter = (event) => {
    if (event.keyCode === 13) {
      event.preventDefault();
      donateFunc();
    }
  };

  return (
    <Popover
      style={{ zIndex: popoverZIndex }}
      open={props.open}
      anchorEl={props.elRefRen.current}
      onClose={props.handleClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
    >
      <div className={classes.popOverContainer}>
        <TextFieldComp
          name='donation'
          label='Donation $*'
          placeholder='Enter amount'
          error={!!errors.donationAmount}
          helpertext={errors.donationAmount}
          value={donationAmount}
          onChange={handleTextChange}
          alignRight={true}
          InputProps={{
            startAdornment: donationAmount ? (
              <InputAdornment position='start'>$</InputAdornment>
            ) : (
              ''
            ),
          }}
          inputStyles={classes.inputStyles}
          handleEnter={handleEnter}
        />

        <TextFieldComp
          name='designation'
          label='Message'
          placeholder='Enter message'
          value={designation}
          onChange={handleDesignationChange}
          inputStyles={classes.inputStyles}
          handleEnter={handleEnter}
        />

        <CustomButton
          btnStyle={classes.btnStyleDonate}
          clickHandle={donateFunc}
          btnText={'Go'}
          endIcon={<ArrowRightAltSharpIcon className={classes.arrowIcon} />}
        />
        <Typography variant='caption' align='center' className={classes.title}>
          For Siddhi Vinayak Mandir
        </Typography>
        <Typography
          variant='caption'
          align='center'
          className={classes.subtitle}
        >
          Global Mall, Atlanta.
        </Typography>
      </div>
    </Popover>
  );
};

export default Donate;
